/**
 * Cart drawer
 */
(function () {
  const drawer = document.getElementById('CartDrawer');
  if (!drawer) return;

  const body = drawer.querySelector('[data-cart-drawer-body]');
  const footer = drawer.querySelector('[data-cart-drawer-footer]');
  const subtotal = drawer.querySelector('[data-cart-subtotal]');

  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    refreshCart();
    window.Alverio.trapFocus(drawer.querySelector('.drawer__panel'));
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-cart-open]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      openDrawer();
    });
  });
  drawer.querySelectorAll('[data-drawer-close]').forEach((btn) => {
    btn.addEventListener('click', closeDrawer);
  });

  window.Alverio.subscribe('cart:open', openDrawer);
  window.Alverio.subscribe('cart:updated', refreshCart);

  async function refreshCart() {
    try {
      const cart = await window.Alverio.getCart();
      if (cart.item_count === 0) {
        body.innerHTML = `<p class="text-muted">${window.themeSettings.strings?.cartEmpty || 'Your cart is empty'}</p>`;
        footer.hidden = true;
        return;
      }

      footer.hidden = false;
      subtotal.textContent = Shopify.formatMoney
        ? Shopify.formatMoney(cart.total_price)
        : (cart.total_price / 100).toFixed(2);

      body.innerHTML = cart.items
        .map(
          (item) => `
          <div class="cart-item" data-key="${item.key}">
            <div class="cart-item__image">${item.image ? `<img src="${item.image}" alt="" width="80" height="80" style="border-radius:var(--radius-card);">` : ''}</div>
            <div>
              <a href="${item.url}" style="font-weight:600;">${item.product_title}</a>
              <p class="text-sm text-muted">${item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : ''}</p>
              <p>${(item.final_line_price / 100).toFixed(2)}</p>
              <div class="flex gap-sm" style="margin-top: 0.5rem;">
                <button type="button" class="btn btn--sm btn--secondary" data-cart-qty-minus aria-label="Decrease quantity">−</button>
                <span data-cart-qty-value>${item.quantity}</span>
                <button type="button" class="btn btn--sm btn--secondary" data-cart-qty-plus aria-label="Increase quantity">+</button>
              </div>
            </div>
          </div>`
        )
        .join('');
    } catch {
      /* noop */
    }
  }

  body?.addEventListener('click', async (event) => {
    const target = /** @type {HTMLElement | null} */ (event.target instanceof HTMLElement ? event.target : null);
    if (!target) return;

    const btn = target.closest('[data-cart-qty-minus],[data-cart-qty-plus]');
    if (!(btn instanceof HTMLElement)) return;

    const itemEl = btn.closest('[data-key]');
    if (!(itemEl instanceof HTMLElement)) return;

    const key = itemEl.getAttribute('data-key');
    if (!key) return;

    const qtyEl = itemEl.querySelector('[data-cart-qty-value]');
    const currentQty = qtyEl ? Number(String(qtyEl.textContent || '').trim()) : NaN;
    if (!Number.isFinite(currentQty)) return;

    const delta = btn.hasAttribute('data-cart-qty-plus') ? 1 : -1;
    const nextQty = Math.max(0, currentQty + delta);

    btn.setAttribute('disabled', 'disabled');
    try {
      const cartChangeUrl = window.themeSettings?.routes?.cartChange || '/cart/change';
      await fetch(`${cartChangeUrl}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: nextQty }),
      });
      refreshCart();
      window.Alverio.publish('cart:updated');
    } catch {
      /* noop */
    } finally {
      btn.removeAttribute('disabled');
    }
  });
})();
